import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formFilter'
})
export class FormFilterPipe implements PipeTransform {

  transform(forms: any[], filter: string): any[] {
    let response = []
    if (filter === '') return forms;
    forms.forEach(form => {
      if (form.title.toLowerCase().indexOf(filter.toLowerCase()) != -1) {
        response.push(form)
      }
    });
    return response;
  }

}
